<template>
    <main>
        <router-view></router-view>
    </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	computed: {
		...mapGetters('auth', ['user']),
	},

	methods: {
		...mapActions('auth', [
			'fetchNotifications',
			'fetchUser',
			'fetchSettings',
			'updateLastActivation',
			'logout'
		]),

		...mapActions('chat', [
			'fetchThreads'
		]),

		...mapActions('job', [
			'resetState'
		]),

		async handleAuthResources() {
			if (! this.user) return
			await this.fetchSettings()
			await this.updateLastActivation()
			await this.resetState()
		},

		async registerConversationListener() {
			if (! this.user) return

			await this.$store.dispatch('chat/fetchThreads')

			window.Echo.private(`${process.env.VUE_APP_PUSHER_APP_CHANNEL}.users.${this.user.uuid}`)
				.stopListening('.conversation.message.created.' + this.user.uuid)
				.listen('.conversation.message.created.' + this.user.uuid, async () => {
					await this.fetchThreads()
				})
		},

		async registerNotificationListener() {
			if (! this.user) return

			await this.fetchNotifications()

			const NotificationEvent = '.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated'
			window.Echo.private(process.env.VUE_APP_PUSHER_APP_CHANNEL)
				.stopListening(NotificationEvent)
				.listen(NotificationEvent, async () => {
					await this.fetchNotifications()
				})
		},

		registerRefreshUserListener() {
			if (! this.user) return

			window.Echo.private(`${process.env.VUE_APP_PUSHER_APP_CHANNEL}.users.${this.user.uuid}`)
				.stopListening('.refresh.user.' + this.user.uuid)
				.listen('.refresh.user.' + this.user.uuid, async () => {
					await this.fetchUser()
				})
		},
	},

	watch: {
		user: {
            deep: true,
			immediate: true,
			async handler() {
				await this.handleAuthResources()
				await this.registerRefreshUserListener()
				await this.registerNotificationListener()
				await this.registerConversationListener()
			},
		}
	}
}
</script>
